export default {
  Object: 'Object',
  EditTheTagObject: 'Edit The Tag Object',
  AddedATagObject: 'Added a Tag Object',
  BasicProperties: 'Basic Properties',
  Code: 'Code',
  TheProjectName: 'The Project Name',
  Name: 'Name',
  ParentObject: 'Parent Object',
  PleaseSelectAStatus: 'Please Select a Status',
  ShortDescription: 'Short Description',
  LongDescription: 'Long Description',
  TemplateProperties: 'Template Properties',
  AssociationRelationships: 'Association Relationships',
  DocumentName: 'Document Name',
  FileName: 'File Name',
  SmartAssociations: 'Smart Associations',
  ManualAssociation: 'Manual Association',
  DisRelation: 'Disassociate',
  WhetherToDisassociate: 'Whether to Disassociate',
  Disassociate: 'Disassociate',
  PleaseEnterAKeyword: 'Please Enter a Keyword',
  ObjectHandover: 'Object Handover',
  ProcessApproval: 'Process Approval',
  TheProcessType: 'The Process Type',
  ProcessStatus: 'Process Status',
  Reviewer: 'Reviewer',
  Deadline: 'Deadline',
  SelectADatetime: 'Select a Datetime',
  UploadTime: 'Upload time',
  Uploader: 'Uploader',
  BrowseForTagAsset: 'Browse for Tag Asset',
  SearchForAssetEncodingsAndAssetNames: 'Search for Asset Encodings and Asset Names',
  SearchForAssetCategories: 'Search for Asset Categories',
  RecursiveDisplay: 'Recursive Display',
  Inquire: 'Inquire',
  handOver: 'Hand Over',
  RuleImport: 'Rule Import',
  tree: 'Tree',
  CorrelationModel: 'Correlation Model',
  CreationTime: 'Creation Time',
  CreateAUser: 'Create a User',
  LastModifiedTime: 'Last Modified Time',
  LastModifyTheUser: 'Last Modify The User',
  DownloadProgress: 'Download Progress',
  NotHandedOver: 'Not Handed Over',
  UnderReview: 'Under Review',
  HandedOver: 'Handed Over',
  TheModelIsAssociated: 'The Model is Associated',
  ModelIsNotAssociated: 'Model is Not Associated',
  AssetHandoverProcess: 'Asset Handover Process',
  PleaseFillInThisField: 'Please fill in This Field',
  PleaseSelectACategory: 'Please Select a Category',
  TagAssetTemplate: 'Tag Asset Template',
  TagAssetImportResult: 'Tag Asset Import Result',
  TheTagAssetExportFile: 'The Tag Asset Export File',
  PleaseEnterATitle: 'Please Enter a Title',
  PleaseSelectAProcessType: 'Please Select a Process Type',
  PleaseSelectADeadline: 'Please Select a Deadline',
  ThereAreNoPermissionsToOperate: 'There Are no Permissions to Operate',
  ThereIsanAssociatedRelationshipPleaseReselect:
    'There is an Associated Relationship, Please Reselect',
  PleaseSelectTheFileYouWantToAssociate: 'Please Select The File You Want to Associate',
  WhetherToDeleteTheCheckedData: 'Whether to Delete the Checked Data',
  DeletionDataThatHasBeenAutomaticallyFilteredForReviewAndTransfErred:
    'Deletion (Data That Has Been Automatically Filtered for Review and TransfErred)',
  DeleteSuccessful: 'Delete Successful',
  CancelTheDeletion: 'Cancel the Deletion',
  PleaseSelectTheDataYouWantToDelete: 'Please Select the Data You Want to Delete',
  ConfirmThatYouWantToContinue: 'Confirm That You Want to Continue',
  PleaseSelectAnObjectThatIsNotHandedOver: 'Please Select an Object That is Not Handed Over',
  DataOnObjectsThatAreUndeReviewAndTransferredHaveBeenAutomaticallyFiltered:
    'Data on Objects That Are Under Review and Transferred Have Been Automatically Filtered',
  In: 'In',
  InitiationProcessObjectPublishingProcess: 'Initiation Process【Object Publishing Process】',
  ReviewersCannotBeEmpty: 'Reviewers Cannot be Empty',
  TheProcessHasBeenSubmitted: 'The Process Has Been Submitted',
  TheProcessIsSaved: 'The Process is Saved',
  ObjectHandoverManagement: 'Object Handover Management',
  ParentCategory: 'Parent Category',
  SearchForEAMAssetCategories: 'Search for EAMClass',
  SearchForACategoryCodeOrCategoryName: 'Search For a Category Code or Category Name',
  NewCategories: 'New Categories',
  ListView: 'List View',
  TreeView: 'Tree View',
  CategoryCode: 'Category Code',
  CategoryName: 'Category Name',
  ParentCategory: 'Parent Category',
  Icon: 'Icon',
  EditTheTagCategory: 'Edit the Tag Category',
  AddedTagCategories: 'Added Tag Categories',
  TheTag: 'The Tag',
  PropertyTemplates: 'Property Templates',
  NoPropertyTemplateIsAssociated: 'No Property Template is Associated',
  ThePropertyTemplateHasBeenAssociated: 'The Property Template Has Been Associated',
  PleaseEnterAPropertyTemplate: 'Please Enter a Property Template',
  CategoryHierarchy: 'Category Hierarchy',
  Inquire: 'Inquire',
  CategoryDetails: 'Category Details',
  CategoryAssociations: 'Category Associations',
  AssociateaDocumentCategory: 'Associate a Document Category',
  ADocumentCategoryHasBeenAssociated: 'A Document Category Has Been Associated',
  TagCategoryTemplate: 'Tag Category Template',
  TagCategoryImportResults: 'Tag Category Import Results',
  TagCategoryExportFile: 'Tag Category Export File',
  ExportFailed: 'Export Failed',
  NoRecordsAreCurrentlySelectedTheSystemWillExportAlltheDataintheSystembyDefaulttheOperationWillTakeaLongTimePleaseConfirmWhetherYouWanttoContinue:
    'No Records Are Currently Selected, The System Will Export All the Data in the System by Default, the Operation Will Take a Long Time, Please Confirm Whether You Want to Continue?',
  TagCategoryManagement: 'Tag Category Management',
  TheOrdinalNumberCannotbeEmpty: 'The Ordinal Number Cannot be Empty',
  TheLengthCannotExceedCharacters: 'The Length Cannot Exceed 10 Characters',
  TheOrdinalNumberMustbeaPositiveIntegerGreaterThan:
    'The Ordinal Number Must be a Positive Integer Greater Than 0',
  DoYouWanttoConfirmDisassociationFromtheTagIfConfirmedtheCategoryforThatTagWillbeCleared:
    'Do You Want to Confirm Disassociation From the Tag? If Confirmed, the Category for That Tag Will be Cleared',
  PleaseFillinTheCategoryCode: 'Please Fill in the Category Code',
  PleaseFillinTheCategoryName: 'Please Fill in the Category Name',
  EdittheAssociationRelationship: 'Edit the Association Relationship',
  PleaseSelectanAssetEncoding: 'Please Select an Asset Encoding',
  PleaseSelectaDocumentName: 'Please Select a Document Name',
  PleaseSelectaFileName: 'Please Select a File Name',
  RefineYourSearch: 'Refine Your Search',
  ParentEncoding: 'Parent Encoding',
  AncestorName: 'Ancestor Name',
  AssociateaDocument: 'Associate a Document',
  TheAssetEncodingCannotbeEmpty: 'The Asset Encoding Cannot be Empty',
  TheFileNameCannotbeEmpty: 'The File Name Cannot be Empty',
  PleaseSelecttheDocumentNameFirst: 'Please Select the Document Name First',
  AddSuccess: 'Add Success',
  PleaseFollowthePromptstoFillintheCorrectForm:
    'Please Follow the Prompts to Fill in the Correct Form',
  WhethertoDeletetheSelectedData: 'Whether to Delete the Selected Data',
  AssetDataManagement: 'Asset Data Management',
}
